import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import styles from "../NotFound/NotFound.module.scss";
import { authVerify } from "../../api/authApi";

const ActivatedPage = () => {
  const [data, setData] = useState();
  const [error, setError] = useState();
  const location = useLocation();

  useEffect(() => {
    const id = location.pathname.split("/activated/")[1];

    if (id) {
      handleVerify(id);
    }
  }, [location]);

  const handleVerify = async (id) => {
    try {
      const response = await authVerify(id);
      console.log(response);

      if (response?.status === 200) {
        setData("Successfully activated");
      } else {
        setData("Something went wrong");
        console.log("else", response);
        setError(true);
      }
    } catch (err) {
      console.log("err", err);
      setData("An error occurred during activation");
      setError(true);
    } finally {
      console.log("finnaly");
    }
  };

  return (
    <div className={styles.notFoundPage}>
      <div className={styles.content}>
        <h2 className={styles.title}>{data}</h2>
        {!error && (
          <p>
            Great! You have successfully registered. Welcome to your personal
            account!
          </p>
        )}
      </div>
      <Link to={"/main"} className={styles.notFoundButton}>
        Main
      </Link>
    </div>
  );
};

export default ActivatedPage;
